<template lang="pug">
  .circle-progress-container
    vue-circle(
      ref="progressComponent"
      :animation-start-value="0.0"
      line-cap="round"
      :start-angle="Math.PI"
      :progress="progress"
      :animation="false"
      :size="100"
      empty-fill="rgba(0, 0, 0, .1)"
      :fill="{ color: \"#ff1e41\" }"
      insert-mode="append"
      :show-percent="false"
    ): slot
</template>
<script>
import VueCircle from 'vue2-circle-progress'
export default {
  components: {
    VueCircle
  },
  props: {
    progress: {
      default: 0
    }
  },
  watch: {
    progress (val) {
      this.$refs.progressComponent.updateProgress(val)
    }
  }
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/upload-files/parts/circle-progress/index.vue